import * as types from '../actions/action-types'
import { setModal, unsetModal } from './modal-actions'
import { MODAL_RELATED_DIAGRAMS } from '../constants'

function setRelatedDiagramsData({ vin, componentId, pins }) {
  return {
    type: types.SET_RELATED_DIAGRAMS_MODAL,
    vin,
    componentId,
    pins,
  }
}

// Opening pushes the shared modal container, so exactly one instance is mounted
// no matter how many pinouts or harness-view tooltips are alive. Keeping the
// data and the container in one action is what stops the two drifting apart.
export function setRelatedDiagramsModal({ vin, componentId, pins = [] }) {
  return (dispatch) => {
    dispatch(setRelatedDiagramsData({ vin, componentId, pins }))
    dispatch(setModal(MODAL_RELATED_DIAGRAMS))
  }
}

export function unsetRelatedDiagramsModal() {
  return (dispatch) => {
    dispatch({ type: types.UNSET_RELATED_DIAGRAMS_MODAL })
    dispatch(unsetModal())
  }
}
